
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tester_sale",
      function () {
        return require("private-next-pages/tester_sale.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tester_sale"])
      });
    }
  